<template>
  <div class="virtual_exhibitions">
    <Header />
    <SubpageSlider :image="require('@/assets/slider/virtualis_slider_image.png')"
                   :overlay_image="require('@/assets/slider/virtualis_slider_overlay.png')"
                    overlay_style="left: 692px; top: 63px;">
      <h2>{{ $route.name }}</h2>
    </SubpageSlider>
    <div class="home-content">
      <div class="row no-gutters">
        <HomeCard :image="require('@/assets/images/Layer_221.png')"
                  style="margin-top: -17px;">
          <a href="http://amml.skanzen.hu/" target="_blank">
            <h2>Amikor minden más lett... Élet a
            nagy háború alatt és után | Virtu-
            ális kiállítás</h2>
          </a>
          <p>Virtuális kiállításunk segítségével megismerheti, hogy miben lettek mások
            a mindennapok a vidéki Magyarországon az első világháború alatt és után.</p>
        </HomeCard>
        <HomeCard :image="require('@/assets/images/Layer_15.png')"
                  style="margin-top: -10px;">
          <router-link :to="{path: '/virtualis-kiallitasok/trianoni-arvak'}">
            <h2>Trianon árvái | Virtuális kiállítás</h2></router-link>
          <p>A trianoni béke következtében a hivatalos statisztikák szerint 350 ezer,
            utólagos becslések szerint pedig mintegy 425 ezer ember hagyta el otthonát.
            A menekültek egy része évekig élt szükségszállásokon vagy pályaudvarokon,
            vasúti vagonokban.</p>
        </HomeCard>
        <HomeCard :image="require('@/assets/images/maszk.png')" style="margin-top: -8px;">
          <router-link to="/virtualis-kiallitasok/mutasd-a-maszkod">
            <h2>Mutasd a maszkod! | Virtuális
              kiállítás</h2></router-link>
          <p>2020 rendkívüli év. A  COVID-19 vírus átalakította mindennapjainkat.
            A Skanzen közösségi
            felhívásban gyűjti azokat a történeteket, amelyek a maszkviseléssel kapcsolatosak.
            Megmutatjuk őket.</p>
        </HomeCard>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import SubpageSlider from '@/components/SubpageSlider.vue';
import HomeCard from '@/components/HomeCard.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'VirtualExhibition',
  components: {
    Header,
    SubpageSlider,
    HomeCard,
    Footer,
  },
};
</script>

<style scoped>

</style>
